import { TextBox } from '@apply/components';
import { AddressFieldLength } from '@apply/constants';
import { useBorrowerEntityCity } from '../../../../../../../queries/BorrowerFields/EntityFields';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface BorrowerCityProps {
    readOnly?: boolean;
    isReview?: boolean;
}

export const BorrowerCity: React.FC<BorrowerCityProps> = ({ readOnly = false, isReview = false }) => {
    const label = 'City';
    const [city, set_city] = useBorrowerEntityCity();
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={city}
                />
            ) : (
                <TextBox
                    value={city}
                    onChange={(value) => set_city(value)}
                    label={label}
                    width='100%'
                    required={true}
                    readOnly={readOnly}
                    maxLength={AddressFieldLength.city}
                />
            )}
        </>
    );
};
